import React from 'react'

import { isEmpty } from 'ramda'
import { useDispatch, useSelector } from 'react-redux'

import { Flex } from '@driftt/dds'
import { Button, H1 } from '@driftt/tide-core'

import { ThirdPartyCards } from 'layouts/ThirdPartySignIn'
import * as actions from 'modules/user/actions'
import * as selectors from 'modules/user/selectors'
import { meetsAllRequirements } from 'utils/password'
import {
  redirectToGoogleLogin,
  redirectToMicrosoftLogin,
} from 'utils/SocialAuthRedirects'

import { PasswordSection } from './PasswordSection'
import { ThirdPartySignUpDivider } from './ThirdPartySignUpDivider'

const canSubmit = (
  password,
  config,
  passwordConfigFetched,
  missingPasswordConfig
) => {
  if (passwordConfigFetched && !missingPasswordConfig) {
    return meetsAllRequirements(password, config)
  } else {
    return !!password
  }
}

export const SignUpStep = () => {
  const dispatch = useDispatch()

  const password = useSelector((state) => selectors.getPassword(state))
  const passwordConfig = useSelector((state) => selectors.passwordConfig(state))
  const passwordConfigFetched = useSelector((state) =>
    selectors.passwordConfigFetched(state)
  )
  const passwordUpdateStatus = useSelector((state) =>
    selectors.passwordUpdateStatus(state)
  )

  const onPasswordChange = (event) =>
    dispatch(actions.setPassword(event.target.value))
  const onContinueClick = () => dispatch(actions.updatePassword())

  const missingPasswordConfig = passwordConfigFetched && isEmpty(passwordConfig)
  const continueDisabled = !canSubmit(
    password,
    passwordConfig,
    passwordConfigFetched,
    missingPasswordConfig
  )
  const passwordPending = passwordUpdateStatus === 'pending'
  return (
    <Flex direction="column" alignItems="center" fullWidth gap={2}>
      <H1>Sign in to Drift</H1>
      <PasswordSection
        password={password}
        passwordConfig={passwordConfig}
        passwordConfigFetched={passwordConfigFetched}
        passwordUpdateStatus={passwordUpdateStatus}
        onPasswordChange={onPasswordChange}
        missingPasswordConfig={missingPasswordConfig}
      />
      <ThirdPartySignUpDivider />
      <ThirdPartyCards
        onGoogleCardClick={redirectToGoogleLogin}
        onMicrosoftCardClick={redirectToMicrosoftLogin}
      />
      {!passwordConfigFetched || missingPasswordConfig ? (
        <Button
          className="no-password-hints-button"
          onClick={onContinueClick}
          disabled={continueDisabled}
          loading={passwordPending}
        >
          Next
        </Button>
      ) : (
        <Button
          onClick={onContinueClick}
          disabled={continueDisabled}
          loading={passwordPending}
        >
          Next
        </Button>
      )}
    </Flex>
  )
}
